module.exports = __webpack_public_path__ + "images/386c80b1a66078e9026d9bcf43e3afeb-profile_overlay.jpg";